import { Navigate, Outlet } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { LoginsRoute } from "../routes";
import { API_BASE_URL } from "../config/config";

interface UserInfo {
    username: string;
    roles: string[];
}

const PrivateRoute: React.FC<{ requiredRole?: string }> = ({ requiredRole }) => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState<UserInfo | null>(null);

    useEffect(() => {
        const checkAuthentication = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/users/authenticated`, {
                    method: "GET",
                    credentials: "include",
                });

                if (response.status === 200) {
                    const data: UserInfo = await response.json();
                    setUser(data);
                } else {
                    setUser(null);
                }
            } catch {
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        checkAuthentication();
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-background">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary border-solid"></div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to={LoginsRoute.url} />;
    }

    if (requiredRole && !user.roles.includes(requiredRole)) {
        return <Navigate to="/" />; // Redirect if not admin
    }

    return <Outlet />;
};

export default PrivateRoute;
